(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    const swatchFrase = document.querySelectorAll('.line-item-swatch.frase');
  const inputFrase = document.getElementById('frase-input');
  if (inputFrase) {
    inputFrase.addEventListener('input', (event) => {
      const value = event.target.value.trim();

      if (value !== '') {
        swatchFrase.forEach((frase) => {
          frase.classList.add('visible');
        });
      } else {
        swatchFrase.forEach((frase) => {
          frase.classList.remove('visible');
        });
      }
    });
  }

  class SwatchLine extends HTMLElement {
    constructor() {
      super();

      this.lineItemLabel = this.querySelector('[data-selected-value]');
      this.radios = this.querySelectorAll('input[type="radio"]');

      this.handleChange = this.handleChange.bind(this);

      this.radios.forEach((input) => {
        input.addEventListener('change', this.handleChange);
      });
      this.firstSelected();
    }

    firstSelected() {
      const primoRadio = this.radios[0];
      if (!primoRadio) return;
      primoRadio.checked = true;
      if (this.lineItemLabel) {
        this.lineItemLabel.innerText = primoRadio.value;
      }
    }

    handleChange(event) {
      if (this.lineItemLabel) {
        this.lineItemLabel.innerText = event.target.value;
      }
    }

    disconnectedCallback() {
      this.radios.forEach((input) => {
        input.removeEventListener('change', this.handleChange);
      });
    }
  }

  customElements.define('swatch-line', SwatchLine);

  class SwatchLineFrase extends SwatchLine {
    constructor() {
      super(); // eredita tutto da SwatchLine

      // Elementi specifici di questo componente
      this.input = document.getElementById('frase-input');
      //this.box = this.querySelector('.line-item-swatch.colore-ricamo');
      this.renderText = document.querySelector('.custom-render-frase');
      //this.colorRadios = this.querySelectorAll('input[type="radio"]');

      if (this.input) {
        this.input.addEventListener('input', this.handleInput.bind(this));
      }
    }

    handleChange(event) {
      super.handleChange(event);

      this.renderText.style.color = this.getSwatchColor(event.target);
    }

    handleInput(event) {
      const value = event.target.value.trim();

      if (this.renderText) {
        this.renderText.innerText = value;
      }

      if (value !== '') {
        //this.box.classList.add('visible');
        const primoRadio = this.radios[0];
        primoRadio.checked = true;
        this.renderText.style.color = this.getSwatchColor(primoRadio);
      } else {
        //this.box.classList.remove('visible');
        this.radios.forEach((radio) => (radio.checked = false));
      }
    }

    getSwatchColor(radioInput) {
      const label = radioInput.nextElementSibling;
      const swatch = label.querySelector('.swatch');
      return swatch ? swatch.dataset.color : '#000';
    }
  }

  customElements.define('swatch-line-frase', SwatchLineFrase);
  } catch(e) { console.error(e); }
})();

})();
